// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__352_g","active":"downloadDropdown_active__2bQa7"};